const POSTAL_RANGES = {
  "Ciudad de México": [
    "01000",
    "19999"
  ],
  "Aguascalientes": [
    "20000",
    "20999"
  ],
  "Baja California": [
    "21000",
    "22999"
  ],
  "Baja California Sur": [
    "23000",
    "23999"
  ],
  "Campeche": [
    "24000",
    "24999"
  ],
  "Coahuila": [
    "25000",
    "27999"
  ],
  "Colima": [
    "28000",
    "28999"
  ],
  "Chiapas": [
    "29000",
    "30999"
  ],
  "Chihuahua": [
    "31000",
    "33999"
  ],
  "Durango": [
    "34000",
    "35999"
  ],
  "Guanajuato": [
    "36000",
    "38999"
  ],
  "Guerrero": [
    "39000",
    "41999"
  ],
  "Hidalgo": [
    "42000",
    "43999"
  ],
  "Jalisco": [
    "44000",
    "49999"
  ],
  "Estado de México": [
    "50000",
    "57999"
  ],
  "Michoacán": [
    "58000",
    "61999"
  ],
  "Morelos": [
    "62000",
    "62999"
  ],
  "Nayarit": [
    "63000",
    "63999"
  ],
  "Nuevo León": [
    "64000",
    "67999"
  ],
  "Oaxaca": [
    "68000",
    "71999"
  ],
  "Puebla": [
    "72000",
    "75999"
  ],
  "Querétaro": [
    "76000",
    "76999"
  ],
  "Quintana Roo": [
    "77000",
    "77999"
  ],
  "San Luis Potosí": [
    "78000",
    "79999"
  ],
  "Sinaloa": [
    "80000",
    "82999"
  ],
  "Sonora": [
    "83000",
    "85999"
  ],
  "Tabasco": [
    "86000",
    "86999"
  ],
  "Tamaulipas": [
    "87000",
    "89999"
  ],
  "Tlaxcala": [
    "90000",
    "90999"
  ],
  "Veracruz": [
    "91000",
    "96999"
  ],
  "Yucatán": [
    "97000",
    "97999"
  ],
  "Zacatecas": [
    "98000",
    "99999"
  ]
};
const LOCAL_POSTAL_TOKENS = ["01*", "02*", "03*", "04*", "05*", "06*", "07*", "08*", "09*", "10*", "11*", "15*", "53000", "5310*", "5311*", "5312*", "5320*", "5321*", "5322*", "5323*", "53240", "52774", "52775", "52776", "52777", "52778", "52779", "52780", "52781", "52782", "52783", "52784", "52785", "52786", "52787"];
export function validMexicanDestination(destination) {
  if (!destination || destination.country !== 'Mexico' || typeof destination.zip !== 'string' || !/^\d{5}$/.test(destination.zip)) return false;
  const province = destination.province === 'México' ? 'Estado de México' : destination.province;
  const range = Object.hasOwn(POSTAL_RANGES,province) ? POSTAL_RANGES[province] : null;
  return !!range && destination.zip >= range[0] && destination.zip <= range[1];
}
export function coveredLocalPostalCode(zip) {
  return typeof zip === 'string' && /^\d{5}$/.test(zip) && LOCAL_POSTAL_TOKENS.some(token => token.endsWith('*') ? zip.startsWith(token.slice(0,-1)) : zip === token);
}
export function fingerprint(cart) {
  return JSON.stringify([cart.currency, cart.total_price, cart.total_discount, cart.discount_codes, cart.cart_level_discount_applications, cart.items?.map(x => [x.key, x.quantity, x.final_line_price, x.requires_shipping, x.selling_plan_allocation])]);
}
export function eligibility(cart, destination, rates, products) {
  if (!cart || !destination || cart.currency !== 'MXN' || !cart.item_count || !Array.isArray(rates) || !rates.length) return {kind:'neutral'};
  if (!validMexicanDestination(destination) || rates.some(r => r.currency && r.currency !== 'MXN')) return {kind:'neutral'};
  if (rates.some(r => r.price === null || r.price === undefined || String(r.price).trim() === '' || !Number.isFinite(Number(r.price)) || Number(r.price) < 0)) return {kind:'neutral'};
  if (coveredLocalPostalCode(destination.zip)) return {kind:'local'};
  if (rates.some(r => Number(r.price) === 0)) return {kind:'free'};
  if (rates.some(r => !Number.isFinite(Number(r.price)) || Number(r.price) < 0)) return {kind:'neutral'};
  if (cart.total_discount > 0 || cart.discount_codes?.some(x => x.applicable) || cart.cart_level_discount_applications?.length || cart.items?.some(x => x.discounts?.length || x.selling_plan_allocation || !x.requires_shipping)) return {kind:'neutral'};
  const threshold = 74900;
  const rateNames = ['Ciudad de México','Estado de México','México'].includes(destination.province) ? ['Ciudad de México (entrega de 48-72 hrs)','Envios ( entrega de 48-72 hrs )'] : ['Envíos ( entrega de 5-8 días hábiles )'];
  if (!threshold || !rates.every(r => r.source === 'shopify' && (rateNames.includes(r.name) || rateNames.includes(r.presentment_name)))) return {kind:'neutral'};
  const gap = threshold - cart.total_price;
  if (!Number.isSafeInteger(gap) || gap <= 0) return {kind:'neutral'};
  const product = gap <= 1800 ? products.find(p => p.id === 40459645681733) : gap <= 2900 ? products.find(p => p.id === 41419269210181) : null;
  const cap = gap <= 1800 ? 1800 : 2900;
  if (!product || !product.available || !Number.isSafeInteger(product.price) || product.price < gap || product.price > cap || cart.items.some(x => x.variant_id === product.id)) return {kind:'neutral'};
  return {kind:'offer',threshold,gap,product};
}

export function quotedSavings(result, rates) {
  if (result?.kind !== 'offer' || !Number.isSafeInteger(result.product?.price) || result.product.price <= 0 || !Array.isArray(rates) || !rates.length) return null;
  const cents = rates.map(rate => {
    if (!rate || typeof rate !== 'object' || (rate.currency && rate.currency !== 'MXN')) return null;
    const value = String(rate.price ?? '').trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(value)) return null;
    const [whole, fraction = ''] = value.split('.');
    const amount = Number(whole) * 100 + Number(fraction.padEnd(2,'0'));
    return Number.isSafeInteger(amount) && amount > 0 ? amount : null;
  });
  if (cents.some(value => value === null)) return null;
  const shipping = Math.min(...cents), net = shipping - result.product.price;
  return Number.isSafeInteger(net) && net > 0 ? {shipping, sachet:result.product.price, net} : null;
}

if (typeof window !== 'undefined') start();
function start() {
  const root = window.Shopify?.routes?.root || '/';
  const elements = new Set();
  const state = {cart:null,destination:null,rates:null,products:[],busy:false,loading:false,error:'',epoch:0,expires:0,config:null};
  let controller, expireTimer, refreshTimer, restored = false;
  const storageKey = 'sarais-sachet-destination-v1';
  const money = cents => new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN',minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents / 100) + ' MXN';
  const string = key => state.config?.strings[key] || '';
  const emit = () => elements.forEach(e => e.render());
  const decision = () => state.expires > Date.now() ? eligibility(state.cart,state.destination,state.rates,state.products) : {kind:'neutral'};
  const storeDestination = destination => { try { destination ? sessionStorage.setItem(storageKey,JSON.stringify(destination)) : sessionStorage.removeItem(storageKey); } catch (_) {} };
  function invalidate(clearDestination = false) {
    state.epoch++; controller?.abort(); state.rates = null; state.expires = 0; state.loading = false;
    clearTimeout(expireTimer);
    document.querySelectorAll('sarais-shipping-estimator .shipping-estimator__results').forEach(result => { result.hidden=true; });
    if (clearDestination) { state.destination = null; storeDestination(null); }
    emit();
  }
  async function json(url, options = {}) {
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store',...options});
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || body.message || string('rate_error'));
    return body;
  }
  function queryString(destination) {
    return new URLSearchParams({'shipping_address[zip]':destination.zip,'shipping_address[country]':destination.country,'shipping_address[province]':destination.province});
  }
  async function quote(destination, signal) {
    const params = queryString(destination);
    const response = await fetch(`${root}cart/prepare_shipping_rates.json?${params}`,{method:'POST',credentials:'same-origin',signal});
    if (!response.ok) throw new Error(string('rate_error'));
    const until = Date.now() + 15000;
    while (Date.now() < until) {
      if (signal.aborted) throw new DOMException('Aborted','AbortError');
      const data = await json(`${root}cart/async_shipping_rates.json?${params}`,{signal});
      if (data !== null) {
        if (!Array.isArray(data.shipping_rates)) throw new Error(string('rate_error'));
        return data.shipping_rates;
      }
      await new Promise(resolve => setTimeout(resolve,350));
    }
    throw new Error(string('rate_error'));
  }
  async function products(signal) {
    return Promise.all(state.config.products.map(async p => {
      try {
        const data = await json(`${root}products/${p.handle}.js`,{signal});
        const variant = data.variants.find(v => Number(v.id) === p.id);
        return {...p,price:variant?.price,available:!!variant?.available,image:variant?.featured_image?.src || data.featured_image || p.image};
      } catch (_) { return {...p,available:false}; }
    }));
  }
  async function refresh({errorOnFailure = false} = {}) {
    invalidate();
    const epoch = state.epoch, destination = state.destination;
    controller = new AbortController();
    const signal = controller.signal;
    const timeout = setTimeout(() => controller?.signal === signal && controller.abort(),20000);
    state.loading = !!destination; emit();
    try {
      const cart = await json(`${root}cart.js`,{signal});
      if (epoch !== state.epoch) return false;
      state.cart = cart;
      if (!destination || !cart.item_count || cart.currency !== 'MXN') { state.loading = false; emit(); return true; }
      const [rates, currentProducts] = await Promise.all([quote(destination,signal),products(signal)]);
      const latestCart = await json(`${root}cart.js`,{signal});
      if (epoch !== state.epoch) return false;
      if (fingerprint(cart) !== fingerprint(latestCart)) { scheduleRefresh(); return false; }
      state.cart = latestCart; state.rates = rates; state.products = currentProducts; state.expires = Date.now() + 60000;
      expireTimer = setTimeout(() => { state.expires = 0; state.rates = null; emit(); },60000);
      state.loading = false; emit();
      return true;
    } catch (error) {
      if (epoch !== state.epoch) return false;
      state.loading = false; state.rates = null; state.expires = 0;
      if (errorOnFailure) state.error = string('rate_error');
      emit(); return false;
    } finally { clearTimeout(timeout); }
  }
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(() => refresh(),200); }
  function init(config) {
    if (state.config) return;
    state.config = config; state.products = config.products;
    if (!restored) {
      restored = true;
      try { const d = JSON.parse(sessionStorage.getItem(storageKey)); if (d && d.country && d.province && d.zip) state.destination = d; } catch (_) {}
    }
    refresh();
  }
  function openEstimator(element) {
    const drawer = element.closest('cart-drawer');
    const scope = drawer || document.querySelector('.shopify-section--main-cart') || document;
    const estimator = scope.querySelector('sarais-shipping-estimator');
    const popover = estimator?.closest('x-drawer-popover');
    if (popover) scope.querySelector(`[aria-controls="${popover.id}"]`)?.click();
    const details = estimator?.closest('details');
    if (details) details.open = true;
    estimator?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    estimator?.querySelector('[name="address[zip]"]')?.focus({preventScroll:true});
  }
  function el(tag, className, content) {
    const node = document.createElement(tag); if (className) node.className = className; if (content !== undefined) node.textContent = content; return node;
  }
  class SachetUpsell extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-sachet-config]').textContent);
      init(this.config); elements.add(this);
      this.abort = new AbortController();
      this.addEventListener('click',event => {
        if (event.target.closest('[data-calculate]')) openEstimator(this);
        if (event.target.closest('[data-add-sachet]')) this.add();
      },{signal:this.abort.signal});
      this.render();
    }
    disconnectedCallback() { elements.delete(this); this.abort?.abort(); }
    render() {
      const status = this.querySelector('.sarais-sachet__status'), offer = this.querySelector('[data-offer]'), alert = this.querySelector('[data-error]');
      if (!status || !offer) return;
      const result = decision();
      status.replaceChildren(); offer.replaceChildren(); offer.hidden = true;
      alert.textContent = state.error; alert.hidden = !state.error;
      if (state.cart && !state.cart.item_count) { this.hidden = true; return; } this.hidden = false;
      if (result.kind === 'local') {
        status.append(el('p','',string('local_delivery')),el('p','sarais-sachet__note',string('local_delivery_note'))); return;
      }
      if (result.kind === 'free') {
        status.append(el('p','',string('free')),el('p','sarais-sachet__note',string('note'))); return;
      }
      if (result.kind !== 'offer') {
        status.append(el('p','',state.loading ? string('calculating') : string('neutral')));
        const button = el('button','sarais-sachet__calculate',string('calculate')); button.type='button';button.dataset.calculate='';status.append(button);return;
      }
      const d = el('p','sarais-sachet__destination',string('destination').replace('{province}',state.destination.province));
      const gap = el('p','sarais-sachet__gap',string('gap').replace('{amount}',money(result.gap)));
      const progress = el('progress','sarais-sachet__progress');progress.max=result.threshold;progress.value=state.cart.total_price;progress.setAttribute('aria-label',string('minimum'));
      status.append(d,gap,el('p','',string('minimum')),progress,el('p','sarais-sachet__threshold',string('threshold').replace('{amount}',money(result.threshold))));
      const card = el('div','sarais-sachet__card'), photo = el('img','sarais-sachet__photo');photo.src=result.product.image;photo.alt=result.product.title;photo.width=160;photo.height=190;photo.loading='lazy';
      const info = el('div','sarais-sachet__info'); const button = el('button','sarais-sachet__button',string('add'));button.type='button';button.dataset.addSachet='';button.disabled=state.busy;button.setAttribute('aria-busy',String(state.busy));
      info.append(el('p','sarais-sachet__label',string('optional')),el('p','sarais-sachet__title',result.product.title),el('p','sarais-sachet__price',money(result.product.price)),button,el('p','sarais-sachet__choice',string('choice')));
      const photoFrame=el('div','sarais-sachet__photo-frame');photoFrame.append(photo);
      const savings = quotedSavings(result,state.rates);
      if (savings) {
        const summary = el('div','sarais-sachet__savings');
        summary.append(el('p','sarais-sachet__savings-title',string('savings_conditional').replace('{amount}',money(savings.net))),el('p','sarais-sachet__savings-detail',string('savings_breakdown').replace('{shipping}',money(savings.shipping)).replace('{sachet}',money(savings.sachet))));
        offer.append(summary);
      }
      card.append(photoFrame,info);offer.append(card,el('p','sarais-sachet__note',string('note')));offer.hidden=false;
    }
    async add() {
      if (state.busy) return;
      const offered = decision(); if (offered.kind !== 'offer') return;
      const before = fingerprint(state.cart), destination = JSON.stringify(state.destination);
      state.busy = true; state.error = ''; emit();
      let sent = false;
      try {
        if (!await refresh({errorOnFailure:true})) throw new Error(string('changed'));
        const checked = decision();
        if (checked.kind !== 'offer' || checked.product.id !== offered.product.id || checked.product.price !== offered.product.price || before !== fingerprint(state.cart) || destination !== JSON.stringify(state.destination)) throw new Error(string('changed'));
        const sections = new Set();document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        sent = true;
        const added = await json(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:checked.product.id,quantity:1}],sections:[...sections].slice(0,5),sections_url:location.pathname})});
        invalidate();
        if (window.themeVariables?.settings.pageType === 'cart' || window.themeVariables?.settings.cartType === 'page') { location.assign(`${root}cart`); return; }
        const cart = await json(`${root}cart.js`);cart.sections = added.sections;
        this.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:added.items || [added],cart}}));
        if ([...sections].every(id => cart.sections?.[id])) document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        state.cart = cart;scheduleRefresh();
      } catch (error) {
        state.error = sent ? `${string('add_error')} ${error.message || ''}` : error.message || string('changed');
        if (sent) { invalidate();document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));scheduleRefresh(); }
      } finally { state.busy=false;emit(); }
    }
  }
  class ShippingEstimator extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();this.button=this.querySelector('[type="button"]');this.results=this.querySelector('[aria-live="polite"]');
      this.button.addEventListener('click',() => this.calculate(),{signal:this.abort.signal});
      const saved = state.destination;
      if (saved) customElements.whenDefined('country-selector').then(() => {
        if (!this.isConnected || saved !== state.destination) return;
        const selector = this.querySelector('country-selector');
        selector.setAttribute('province',saved.province);
        const country = this.querySelector('[name="address[country]"]');country.value=saved.country;country.dispatchEvent(new Event('change'));
        this.querySelector('[name="address[province]"]').value=saved.province;
        this.querySelector('[name="address[zip]"]').value=saved.zip;
      });
      for (const input of this.querySelectorAll('input,select')) input.addEventListener('input',() => { invalidate(true); this.results.hidden=true; },{signal:this.abort.signal});
      for (const input of this.querySelectorAll('select')) input.addEventListener('change',event => { if (event.isTrusted) { invalidate(true); this.results.hidden=true; } },{signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
    async calculate() {
      if (this.button.disabled) return;
      const destination={country:this.querySelector('[name="address[country]"]').value,province:this.querySelector('[name="address[province]"]').value,zip:this.querySelector('[name="address[zip]"]').value.trim()};
      this.results.replaceChildren();this.results.hidden=false;
      if (!destination.country || (destination.country === 'Mexico' && !validMexicanDestination(destination))) { invalidate(true);this.results.hidden=false;this.results.append(el('p','',string('validate_destination')));return; }
      invalidate();state.destination=destination;storeDestination(destination);state.error='';this.button.disabled=true;this.button.setAttribute('aria-busy','true');
      const ok=await refresh({errorOnFailure:true});
      this.button.disabled=false;this.button.removeAttribute('aria-busy');
      this.results.replaceChildren();this.results.hidden=false;
      if (!ok || !state.rates) { this.results.append(el('p','',string('rate_error')));return; }
      this.results.append(el('p','',state.rates.length ? string('rates_title') : string('no_rates')));
      const list=el('ul','list-disc');for (const rate of state.rates) list.append(el('li','',`${rate.presentment_name || rate.name}: ${rate.currency || state.cart.currency} ${rate.price}`));this.results.append(list);
    }
  }
  customElements.define('sarais-sachet-upsell',SachetUpsell);
  customElements.define('sarais-shipping-estimator',ShippingEstimator);
  document.addEventListener('line-item:will-change',() => { invalidate();state.error=''; });
  document.addEventListener('cart:change',event => { invalidate();state.cart=event.detail.cart;state.error='';scheduleRefresh(); });
  document.addEventListener('cart:refresh',() => { invalidate();scheduleRefresh(); });
  document.addEventListener('cart:discount:error',() => { invalidate();scheduleRefresh(); });
  document.addEventListener('input',event => { if (event.target.closest('cart-discount-field')) invalidate(); },true);
  document.addEventListener('change',event => { if (event.target.closest('cart-discount-field')) invalidate(); },true);
  document.addEventListener('submit',event => { if (event.target.closest('product-form')) invalidate(); },true);
  document.addEventListener('click',event => { if (event.target.closest('cart-discount-remove-button')) invalidate(); },true);
  window.addEventListener('pageshow',event => { if (event.persisted) { invalidate();scheduleRefresh(); } });
  window.addEventListener('focus',() => { if (state.config && !state.busy) { invalidate();scheduleRefresh(); } });
}
